import { render, staticRenderFns } from "./b-table.vue?vue&type=template&id=a73b017a&"
import script from "./b-table.vue?vue&type=script&lang=js&"
export * from "./b-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wd\\fin24\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a73b017a')) {
      api.createRecord('a73b017a', component.options)
    } else {
      api.reload('a73b017a', component.options)
    }
    module.hot.accept("./b-table.vue?vue&type=template&id=a73b017a&", function () {
      api.rerender('a73b017a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/b-table.vue"
export default component.exports